// Mocaverse NFT data
export const mocaverseNFTs = [
 {
    id: 8886,
    name: 'Mocaverse #8886',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/146',
    price: '2.58 ETH'
},
{
    id: 8887,
    name: 'Mocaverse #8887',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/147',
    price: '2.58 ETH'
},
{
    id: 8885,
    name: 'Mocaverse #8885',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/145',
    price: '2.58 ETH'
},
{
    id: 8884,
    name: 'Mocaverse #8884',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/144',
    price: '2.58 ETH'
},
{
    id: 8883,
    name: 'Mocaverse #8883',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/143',
    price: '2.58 ETH'
},
{
    id: 8881,
    name: 'Mocaverse #8881',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/141',
    price: '2.58 ETH'
},
{
    id: 8878,
    name: 'Mocaverse #8878',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/138',
    price: '2.58 ETH'
},
{
    id: 8882,
    name: 'Mocaverse #8882',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/142',
    price: '2.58 ETH'
},
{
    id: 8880,
    name: 'Mocaverse #8880',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/140',
    price: '2.88 ETH'
},
{
    id: 8879,
    name: 'Mocaverse #8879',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/139',
    price: '2.89 ETH'
},
{
    id: 8876,
    name: 'Mocaverse #8876',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/136',
    price: '2.93 ETH'
},
{
    id: 8877,
    name: 'Mocaverse #8877',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/137',
    price: '3.18 ETH'
},
{
    id: 8875,
    name: 'Mocaverse #8875',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/135',
    price: '3.18 ETH'
},
{
    id: 8872,
    name: 'Mocaverse #8872',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/132',
    price: '3.18 ETH'
},
{
    id: 8871,
    name: 'Mocaverse #8871',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/131',
    price: '3.24 ETH'
},
{
    id: 8869,
    name: 'Mocaverse #8869',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/129',
    price: '3.85 ETH'
},
{
    id: 8870,
    name: 'Mocaverse #8870',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/130',
    price: '3.92 ETH'
},
{
    id: 8868,
    name: 'Mocaverse #8868',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/128',
    price: '3.67 ETH'
},
{
    id: 8867,
    name: 'Mocaverse #8867',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/127',
    price: '4.05 ETH'
},
{
    id: 8866,
    name: 'Mocaverse #8866',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/126',
    price: '3.78 ETH'
},
{
    id: 8863,
    name: 'Mocaverse #8863',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/123',
    price: '3.95 ETH'
},
{
    id: 8865,
    name: 'Mocaverse #8865',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/125',
    price: '3.58 ETH'
},
{
    id: 8864,
    name: 'Mocaverse #8864',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/124',
    price: '3.73 ETH'
},
{
    id: 8862,
    name: 'Mocaverse #8862',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/122',
    price: '4.08 ETH'
},
{
    id: 8861,
    name: 'Mocaverse #8861',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/121',
    price: '3.82 ETH'
},
{
    id: 8860,
    name: 'Mocaverse #8860',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/120',
    price: '3.63 ETH'
},
{
    id: 8858,
    name: 'Mocaverse #8858',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/118',
    price: '3.97 ETH'
},
{
    id: 8859,
    name: 'Mocaverse #8859',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/119',
    price: '3.88 ETH'
},
{
    id: 8857,
    name: 'Mocaverse #8857',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/117',
    price: '3.71 ETH'
},
{
    id: 8856,
    name: 'Mocaverse #8856',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/116',
    price: '3.55 ETH'
},
{
    id: 8855,
    name: 'Mocaverse #8855',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/115',
    price: '4.02 ETH'
},
{
    id: 8854,
    name: 'Mocaverse #8854',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/114',
    price: '3.93 ETH'
},
{
    id: 8851,
    name: 'Mocaverse #8851',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/111',
    price: '3.68 ETH'
},
{
    id: 8852,
    name: 'Mocaverse #8852',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/112',
    price: '3.83 ETH'
},
{
    id: 8850,
    name: 'Mocaverse #8850',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/110',
    price: '3.75 ETH'
},
{
    id: 8849,
    name: 'Mocaverse #8849',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/109',
    price: '4.00 ETH'
},
{
    id: 8847,
    name: 'Mocaverse #8847',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/107',
    price: '3.87 ETH'
},
{
    id: 8848,
    name: 'Mocaverse #8848',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/108',
    price: '3.65 ETH'
},
{
    id: 8846,
    name: 'Mocaverse #8846',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/106',
    price: '3.98 ETH'
},
{
    id: 8845,
    name: 'Mocaverse #8845',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/105',
    price: '3.52 ETH'
},
{
    id: 8844,
    name: 'Mocaverse #8844',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/104',
    price: '3.90 ETH'
},
{
    id: 8843,
    name: 'Mocaverse #8843',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/103',
    price: '3.77 ETH'
},
{
    id: 8841,
    name: 'Mocaverse #8841',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/101',
    price: '3.61 ETH'
},
{
    id: 8842,
    name: 'Mocaverse #8842',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/102',
    price: '3.94 ETH'
},
{
    id: 8840,
    name: 'Mocaverse #8840',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/100',
    price: '3.80 ETH'
},
{
    id: 8839,
    name: 'Mocaverse #8839',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/99',
    price: '3.69 ETH'
},
{
    id: 8838,
    name: 'Mocaverse #8838',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/98',
    price: '4.07 ETH'
},
{
    id: 8837,
    name: 'Mocaverse #8837',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/97',
    price: '3.72 ETH'
},
{
    id: 8836,
    name: 'Mocaverse #8836',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/96',
    price: '3.89 ETH'
},
{
    id: 8835,
    name: 'Mocaverse #8835',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/95',
    price: '3.96 ETH'
},
{
    id: 8825,
    name: 'Mocaverse #8825',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/85',
    price: '3.59 ETH'
},
{
    id: 8834,
    name: 'Mocaverse #8834',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/94',
    price: '4.85 ETH'
},
{
    id: 8826,
    name: 'Mocaverse #8826',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/86',
    price: '4.32 ETH'
},
{
    id: 8828,
    name: 'Mocaverse #8828',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/88',
    price: '4.67 ETH'
},
{
    id: 8829,
    name: 'Mocaverse #8829',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/89',
    price: '4.93 ETH'
},
{
    id: 8827,
    name: 'Mocaverse #8827',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/87',
    price: '4.28 ETH'
},
{
    id: 8831,
    name: 'Mocaverse #8831',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/91',
    price: '4.75 ETH'
},
  {
    id: 8833,
    name: 'Mocaverse #8833',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/93',
    price: '4.42'
  },
  {
    id: 8824,
    name: 'Mocaverse #8824',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/84',
    price: '4.88'
  },
  {
    id: 8823,
    name: 'Mocaverse #8823',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/83',
    price: '4.15'
  },
  {
    id: 8822,
    name: 'Mocaverse #8822',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/82',
    price: '4.97'
  },
  {
    id: 8821,
    name: 'Mocaverse #8821',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/81',
    price: '4.53'
  },
  {
    id: 8820,
    name: 'Mocaverse #8820',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/80',
    price: '4.38'
  },
  {
    id: 8819,
    name: 'Mocaverse #8819',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/79',
    price: '4.82'
  },
  {
    id: 8818,
    name: 'Mocaverse #8818',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/78',
    price: '4.23'
  },
  {
    id: 8817,
    name: 'Mocaverse #8817',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/77',
    price: '4.71'
  },
  {
    id: 8815,
    name: 'Mocaverse #8815',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/75',
    price: '4.95'
  },
  {
    id: 8814,
    name: 'Mocaverse #8814',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/74',
    price: '4.47'
  },
  {
    id: 8816,
    name: 'Mocaverse #8816',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/76',
    price: '4.63'
  },
  {
    id: 8813,
    name: 'Mocaverse #8813',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/73',
    price: '4.18'
  },
  {
    id: 8812,
    name: 'Mocaverse #8812',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/72',
    price: '4.78'
  },
  {
    id: 8811,
    name: 'Mocaverse #8811',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/71',
    price: '4.35'
  },
  {
    id: 8810,
    name: 'Mocaverse #8810',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1543',
    price: '4.92'
  },
  {
    id: 8809,
    name: 'Mocaverse #8809',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1542',
    price: '4.57'
  },
  {
    id: 8808,
    name: 'Mocaverse #8808',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1541',
    price: '4.25'
  },
  {
    id: 8807,
    name: 'Mocaverse #8807',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1540',
    price: '4.83'
  },
  {
    id: 8806,
    name: 'Mocaverse #8806',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1539',
    price: '4.45'
  },
  {
    id: 8805,
    name: 'Mocaverse #8805',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1538',
    price: '4.68'
  },
  {
    id: 8803,
    name: 'Mocaverse #8803',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1536',
    price: '4.13'
  },
  {
    id: 8804,
    name: 'Mocaverse #8804',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1537',
    price: '4.73'
  },
  {
    id: 8802,
    name: 'Mocaverse #8802',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1535',
    price: '4.33'
  },
  {
    id: 8801,
    name: 'Mocaverse #8801',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1534',
    price: '4.87'
  },
  {
    id: 8800,
    name: 'Mocaverse #8800',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1533',
    price: '4.52'
  },
  {
    id: 8798,
    name: 'Mocaverse #8798',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1531',
    price: '4.98'
  },
  {
    id: 8799,
    name: 'Mocaverse #8799',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1532',
    price: '4.65'
  },
  {
    id: 8853,
    name: 'Mocaverse #8853',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/113',
    price: '4.22'
  },
  {
    id: 8874,
    name: 'Mocaverse #8874',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/134',
    price: '4.77'
  },
  {
    id: 8873,
    name: 'Mocaverse #8873',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/133',
    price: '4.43'
  },
  {
    id: 8832,
    name: 'Mocaverse #8832',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/92',
    price: '4.91'
  },
  {
    id: 8830,
    name: 'Mocaverse #8830',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/90',
    price: '4.58'
  },
  {
    id: 8797,
    name: 'Mocaverse #8797',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/70',
    price: '4.37'
  },
  {
    id: 8796,
    name: 'Mocaverse #8796',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/69',
    price: '4.81'
  },
  {
    id: 8794,
    name: 'Mocaverse #8794',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/67',
    price: '4.27'
  },
  {
    id: 8791,
    name: 'Mocaverse #8791',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/64',
    price: '4.62'
  },
  {
    id: 8790,
    name: 'Mocaverse #8790',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/63',
    price: '4.96'
  },
  {
    id: 8788,
    name: 'Mocaverse #8788',
    image: 'https://ipfs.io/ipfs/QmXZcT8b94a6jngckdSRP8vn279J7wHgDoS2f99B4PbL1W/1106',
    price: '4.48'
  },
  {
    id: 8789,
    name: 'Mocaverse #8789',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/62',
    price: '4.17'
  },
  {
    id: 8795,
    name: 'Mocaverse #8795',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/68',
    price: '4.72'
  },
  {
    id: 8792,
    name: 'Mocaverse #8792',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/65',
    price: '4.55'
  },
  {
    id: 8793,
    name: 'Mocaverse #8793',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/66',
    price: '4.33'
  },
    {
    id: 8833,
    name: 'Mocaverse #8833',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/93',
    price: '4.42 ETH'
},
{
    id: 8824,
    name: 'Mocaverse #8824',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/84',
    price: '4.88 ETH'
},
{
    id: 8823,
    name: 'Mocaverse #8823',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/83',
    price: '4.15 ETH'
},
{
    id: 8822,
    name: 'Mocaverse #8822',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/82',
    price: '4.97 ETH'
},
{
    id: 8821,
    name: 'Mocaverse #8821',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/81',
    price: '4.53 ETH'
},
{
    id: 8820,
    name: 'Mocaverse #8820',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/80',
    price: '4.38 ETH'
},
{
    id: 8819,
    name: 'Mocaverse #8819',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/79',
    price: '4.82 ETH'
},
{
    id: 8818,
    name: 'Mocaverse #8818',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/78',
    price: '4.23 ETH'
},
{
    id: 8817,
    name: 'Mocaverse #8817',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/77',
    price: '4.71 ETH'
},
{
    id: 8815,
    name: 'Mocaverse #8815',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/75',
    price: '4.95 ETH'
},
{
    id: 8814,
    name: 'Mocaverse #8814',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/74',
    price: '4.47 ETH'
},
{
    id: 8816,
    name: 'Mocaverse #8816',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/76',
    price: '4.63 ETH'
},
{
    id: 8813,
    name: 'Mocaverse #8813',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/73',
    price: '4.18 ETH'
},
{
    id: 8812,
    name: 'Mocaverse #8812',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/72',
    price: '4.78 ETH'
},
{
    id: 8811,
    name: 'Mocaverse #8811',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/71',
    price: '4.35 ETH'
},
{
    id: 8810,
    name: 'Mocaverse #8810',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1543',
    price: '4.92 ETH'
},
{
    id: 8809,
    name: 'Mocaverse #8809',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1542',
    price: '4.57 ETH'
},
{
    id: 8808,
    name: 'Mocaverse #8808',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1541',
    price: '4.25 ETH'
},
{
    id: 8807,
    name: 'Mocaverse #8807',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1540',
    price: '4.83 ETH'
},
{
    id: 8806,
    name: 'Mocaverse #8806',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1539',
    price: '4.45 ETH'
},
{
    id: 8805,
    name: 'Mocaverse #8805',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1538',
    price: '4.68 ETH'
},
{
    id: 8803,
    name: 'Mocaverse #8803',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1536',
    price: '4.13 ETH'
},
{
    id: 8804,
    name: 'Mocaverse #8804',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1537',
    price: '4.73 ETH'
},
{
    id: 8802,
    name: 'Mocaverse #8802',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1535',
    price: '4.33 ETH'
},
{
    id: 8801,
    name: 'Mocaverse #8801',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1534',
    price: '4.87 ETH'
},
{
    id: 8800,
    name: 'Mocaverse #8800',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1533',
    price: '4.52 ETH'
},
{
    id: 8798,
    name: 'Mocaverse #8798',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1531',
    price: '4.98 ETH'
},
{
    id: 8799,
    name: 'Mocaverse #8799',
    image: 'https://ipfs.io/ipfs/Qme5CLY4hjfZ6kLzhZamPywRRCUYF4iqTqgQK7HxTtXatW/1532',
    price: '4.65 ETH'
},
{
    id: 8853,
    name: 'Mocaverse #8853',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/113',
    price: '4.22 ETH'
},
{
    id: 8874,
    name: 'Mocaverse #8874',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/134',
    price: '4.77 ETH'
},
{
    id: 8873,
    name: 'Mocaverse #8873',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/133',
    price: '4.43 ETH'
},
{
    id: 8832,
    name: 'Mocaverse #8832',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/92',
    price: '4.91 ETH'
},
{
    id: 8830,
    name: 'Mocaverse #8830',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/90',
    price: '4.58 ETH'
},
{
    id: 8797,
    name: 'Mocaverse #8797',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/70',
    price: '4.37 ETH'
},
{
    id: 8796,
    name: 'Mocaverse #8796',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/69',
    price: '4.81 ETH'
},
{
    id: 8794,
    name: 'Mocaverse #8794',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/67',
    price: '4.27 ETH'
},
{
    id: 8791,
    name: 'Mocaverse #8791',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/64',
    price: '4.62 ETH'
},
{
    id: 8790,
    name: 'Mocaverse #8790',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/63',
    price: '4.96 ETH'
},
{
    id: 8788,
    name: 'Mocaverse #8788',
    image: 'https://ipfs.io/ipfs/QmXZcT8b94a6jngckdSRP8vn279J7wHgDoS2f99B4PbL1W/1106',
    price: '4.48 ETH'
},
{
    id: 8789,
    name: 'Mocaverse #8789',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/62',
    price: '4.17 ETH'
},
{
    id: 8795,
    name: 'Mocaverse #8795',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/68',
    price: '4.72 ETH'
},
{
    id: 8792,
    name: 'Mocaverse #8792',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/65',
    price: '4.55 ETH'
},
{
    id: 8793,
    name: 'Mocaverse #8793',
    image: 'https://ipfs.io/ipfs/QmTSATKwnwD7LmGwmsT5jsxXvsw8azSLJbrrN4nwmipDCk/66',
    price: '4.33 ETH'
}


    
];
